import { CALL_API } from '../middleware/ApiMiddleware';

export const GET_FINANCE_REPORT_LIST_REQUEST = 'GET_FINANCE_REPORT_LIST_REQUEST';
export const GET_FINANCE_REPORT_LIST_FAILURE = 'GET_FINANCE_REPORT_LIST_FAILURE';
export const GET_FINANCE_REPORT_LIST_SUCCESS = 'GET_FINANCE_REPORT_LIST_SUCCESS';

export const DOWNLOAD_FINANCE_REPORT_REQUEST = 'DOWNLOAD_FINANCE_REPORT_REQUEST';
export const DOWNLOAD_FINANCE_REPORT_SUCCESS = 'DOWNLOAD_FINANCE_REPORT_SUCCESS';
export const DOWNLOAD_FINANCE_REPORT_FAILURE = 'DOWNLOAD_FINANCE_REPORT_FAILURE';

const baseURL = 'xerce/finance-reports';

export const fetchFinanceReportList = (listFilters: IFinanceReportListFilters, hideLoadingWidget = false) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    body: listFilters,
    authenticated: true,
    types: [GET_FINANCE_REPORT_LIST_REQUEST, GET_FINANCE_REPORT_LIST_SUCCESS, GET_FINANCE_REPORT_LIST_FAILURE],
    hideLoadingWidget,
  },
});

export const dowloadFinanceReports = (id: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${id}/download`,
    method: 'get',
    authenticated: true,
    body: {},
    types: [DOWNLOAD_FINANCE_REPORT_REQUEST, DOWNLOAD_FINANCE_REPORT_SUCCESS, DOWNLOAD_FINANCE_REPORT_FAILURE],
  },
});
